exports.DISABLE_INSTALL_BROWSERS = ['opera', 'ecosia android', 'ecosia ios'];
exports.SUPPORTED_SAFARI_VERSION = 14;
exports.EDGE_LEGACY_VERSION = 18;
exports.BLOCKED_BROWSERS = ['vivaldi', 'iemobile', 'opera', 'waterfox'];
